const CrudStatus = {
  IDLE: 100,
  SUCCESS: 200,
  PENDING: 300,
  ERROR: 400,
};
// eslint-disable-next-line import/prefer-default-export
export { CrudStatus };
